type ReplaceableCallReceiveCallbackFn = (callId: string) => void
const callbackSet: Set<ReplaceableCallReceiveCallbackFn> = new Set()

export const onReplaceableCallReceive = (callback: ReplaceableCallReceiveCallbackFn) => {
  callbackSet.add(callback)
  const unListenFn = () => callbackSet.delete(callback)
  return unListenFn
}

export const fireReplaceableCallReceiveEvent = (callId: string) => {
  callbackSet.forEach((callback: ReplaceableCallReceiveCallbackFn) => {
    callback(callId)
  })
}
